import react from "react";
import Request from "../../../../api/Requests";

const getVenuesApprovalList = (params) => {
    
    return Request('admin/venues-list-approval', 'GET', params, true);
}

const getVenuesApprovalInfo = (params) => {
    return Request('admin/venues-info-approval', 'GET', params, true);
}

const approveVenue = (params) => {
    return Request('admin/venues-approve', 'GET', params, true);
}


const getVenuesList = (params) => {
    return Request('admin/venues-list', 'GET', params, true);
}

const getEventList = (params, filter) => {
    params["filter"] = filter;
    return Request('admin/events-list', 'GET', params, true);
}

export default {
    getVenuesApprovalList,
    getVenuesApprovalInfo,
    approveVenue,
    getVenuesList,
    getEventList
}